import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    'Orthodontics',
    'Dental Implants',
    'Implant Repairs',
    'Bone Graft & Sinus Lift',
    'Cosmetic Dentistry',
    'Composite Restoration',
    'PFM & Zirconia Crowns',
    'Partial & Complete Dentures',
    'Root Canal Treatment (RCT)',
    'Simple & Surgical Extractions',
    'Impactions & Apicectomies',
    'Scaling & Root Planning (SRP)',
    'Oral & Maxillofacial Surgery',
    'Soft Tissue Surgeries',
    'Tongue Tie Treatment',
    'Biopsies',
    'Mole & Wart Removal',
    'TMJ Disorders Treatment',
    'Conscious Sedation',
    'Anesthesiologist Services'
  ];

  const serviceLinks = [
    { name: 'Orthodontics', slug: 'orthodontics' },
    { name: 'Dental Implants', slug: 'implants' },
    { name: 'Implant Repairs', slug: 'implants' },
    { name: 'Bone Graft & Sinus Lift', slug: 'implants' },
    { name: 'Cosmetic Dentistry', slug: 'cosmetic' },
    { name: 'Composite Restoration', slug: 'cosmetic' },
    { name: 'PFM & Zirconia Crowns', slug: 'cosmetic' },
    { name: 'Partial & Complete Dentures', slug: 'cosmetic' },
    { name: 'Root Canal Treatment (RCT)', slug: 'restorative' },
    { name: 'Simple & Surgical Extractions', slug: 'restorative' },
    { name: 'Impactions & Apicectomies', slug: 'restorative' },
    { name: 'Scaling & Root Planning (SRP)', slug: 'periodontics' },
    { name: 'Oral & Maxillofacial Surgery', slug: 'surgery' },
    { name: 'Soft Tissue Surgeries', slug: 'surgery' },
    { name: 'Tongue Tie Treatment', slug: 'surgery' },
    { name: 'Biopsies', slug: 'surgery' },
    { name: 'Mole & Wart Removal', slug: 'surgery' },
    { name: 'TMJ Disorders Treatment', slug: 'tmj' },
    { name: 'Conscious Sedation', slug: 'anesthesia' },
    { name: 'Anesthesiologist Services', slug: 'anesthesia' }
  ];

  const quickLinks = [
    { name: 'About Us', to: '/#about' },
    { name: 'Our Services', to: '/services' },
    { name: 'Our Work', to: '/#work' },
    { name: 'Testimonials', to: '/testimonials' },
    { name: 'Our Team', to: '/our-team' },
    { name: 'Contact Us', to: '/contact' }
  ];

  const socialLinks = [
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/profile.php?id=100063863683088&locale=hi_IN&_rdr',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      )
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/p/C-qJXuSIHmV/?hl=ne',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987 6.62 0 11.987-5.367 11.987-11.987C24.014 5.367 18.637.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.323-1.297C3.95 14.81 3.455 13.66 3.455 12.362c0-1.297.495-2.448 1.297-3.324.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.807.876 1.297 2.027 1.297 3.324 0 1.298-.49 2.449-1.297 3.325-.875.807-2.026 1.297-3.323 1.297z"/>
        </svg>
      )
    },
    {
      name: 'WhatsApp',
      href: 'https://wa.me/923080006494',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.51 3.488"/>
        </svg>
      )
    }
  ];

  return (
    <footer className="footer">
      {/* Main Footer Content */}
      <div className="footer-container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="brand-logo">
              <div className="logo-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
                </svg>
              </div>
              <div className="brand-text">
                <h3>Prime Care Dental</h3>
                <span>Dental Clinic</span>
              </div>
            </div>
            <p className="brand-description">
              Your trusted partner for achieving the perfect smile. Dr. Muhammad Junaid 
              provides comprehensive dental care with expertise in Lahore.
            </p>
            
            {/* Social Links */}
            <div className="social-links">
              <h4>Follow Us</h4>
              <div className="social-icons">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                    aria-label={social.name}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Services Section */}
          <div className="footer-section">
            <h4 className="section-title">Our Services</h4>
            <ul className="footer-links">
              {serviceLinks.map((service, index) => (
                <li key={index}>
                  <Link to={`/service/${service.slug}`} className="footer-link">
                    <svg className="link-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z"/>
                    </svg>
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links Section */}
          <div className="footer-section">
            <h4 className="section-title">Quick Links</h4>
            <ul className="footer-links">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.to} className="footer-link">
                    <svg className="link-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z"/>
                    </svg>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info Section */}
          <div className="footer-section">
            <h4 className="section-title">Contact Information</h4>
            <div className="contact-info">
              <div className="contact-item">
                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.13 15.87 2 12 2M12 11.5C10.62 11.5 9.5 10.38 9.5 9S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5Z"/>
                </svg>
                <div>
                  <strong>Address:</strong>
                  <p>45 F main market Gulberg 2 Lahore</p>
                </div>
              </div>
              
              <div className="contact-item">
                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"/>
                </svg>
                <div>
                  <strong>Phone:</strong>
                  <p>0308 0006494</p>
                </div>
              </div>
              
              <div className="contact-item">
                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4M20 8L12 13L4 8V6L12 11L20 6V8Z"/>
                </svg>
                <div>
                  <strong>Email:</strong>
                  <p>drmjunaid14384@gmail.com</p>
                </div>
              </div>

              <div className="contact-item">
                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12.5 7V12.25L17 14.92L16.25 16.15L11 13V7H12.5Z"/>
                </svg>
                <div>
                  <strong>Working Hours:</strong>
                  <p>Daily: 3:00 PM - 10:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter Subscription */}
        <div className="newsletter-section">
          <div className="newsletter-content">
            <div className="newsletter-info">
              <h3>Stay Updated with Prime Care Dental</h3>
              <p>Subscribe to our newsletter for dental health tips, treatment updates, and special offers from Dr. Muhammad Junaid.</p>
            </div>
            <form className="newsletter-form">
              <div className="input-group">
                <input
                  type="email"
                  placeholder="Enter your email address"
                  className="newsletter-input"
                  required
                />
                <button type="submit" className="newsletter-btn">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z"/>
                  </svg>
                  Subscribe
                </button>
              </div>
              <div className="newsletter-privacy">
                <label className="privacy-checkbox">
                  <input type="checkbox" required />
                  <span className="checkmark"></span>
                  I agree to receive emails and promotional messages from Prime Care Dental
                </label>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="bottom-content">
            <div className="copyright">
              <p>&copy; {currentYear} Prime Care Dental. All rights reserved.</p>
              <p>Designed with ❤️ for beautiful smiles in Pakistan</p>
            </div>
            
            {/* <div className="footer-legal">
              <Link to="/privacy" className="legal-link">Privacy Policy</Link>
              <span className="separator">•</span>
              <Link to="/terms" className="legal-link">Terms of Service</Link>
              <span className="separator">•</span>
              <Link to="/disclaimer" className="legal-link">Medical Disclaimer</Link>
              <span className="separator">•</span>
              <Link to="/sitemap" className="legal-link">Sitemap</Link>
            </div> */}
            
            <div className="certifications">
              <div className="cert-badge">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
                </svg>
                <span>Pakistan Medical & Dental Council Certified</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background Elements */}
      <div className="footer-bg-elements">
        <div className="bg-pattern bg-pattern-1"></div>
        <div className="bg-pattern bg-pattern-2"></div>
      </div>
    </footer>
  );
};

export default Footer; 